export interface GuestGroup {
  bookingId: string
  guests: { sessionId: string; name: string }[]
}

interface PlayerLike {
  role?: string
  name?: string
  serverVirtualRoomId?: string
  guestBookingId?: string
}

/**
 * The first booking of mine with guests waiting in this reception, or null.
 *
 * `broadcastVrOf` must win over the schema's `serverVirtualRoomId`: under StateView AoI the
 * schema field stops updating on observers, so after a guest is teleported out the host's copy
 * still says "reception" and the escort panel never closes. The `vr` on every playerMove reaches
 * all observers — the same precedence `getRemoteServerVirtualRoomId` uses for media.
 */
export function findReceptionGuestGroup(
  players: Iterable<[string, PlayerLike]>,
  receptionRoomId: string,
  myBookingIds: ReadonlySet<string>,
  broadcastVrOf: (sessionId: string) => string | null
): GuestGroup | null {
  const grouped = new Map<string, { sessionId: string; name: string }[]>()
  for (const [sessionId, player] of players) {
    if (player.role !== 'guest') continue
    const vr = broadcastVrOf(sessionId) || player.serverVirtualRoomId || ''
    if (vr !== receptionRoomId) continue
    const bid = player.guestBookingId
    if (!bid || !myBookingIds.has(bid)) continue
    if (!grouped.has(bid)) grouped.set(bid, [])
    grouped.get(bid)!.push({ sessionId, name: player.name || 'Guest' })
  }
  for (const [bookingId, guests] of grouped) return { bookingId, guests }
  return null
}
